import type { OrderActionType } from 'state/secondaryMarket/shared/actions';

export const secondaryMarketOriginalFormActionsFactory = <ActionType extends OrderActionType, AmendResponse>(
  actionType: ActionType,
) => ({
  secondaryMarketAmendFetchRequested: (tabId: string, orderId: string) => ({
    type: `SECONDARY_MARKET_AMEND_${actionType}_FETCH_REQUESTED` as const,
    tabId,
    orderId,
  }),
  secondaryMarketAmendFetched: (tabId: string, orderId: string, data: AmendResponse) => ({
    type: `SECONDARY_MARKET_AMEND_${actionType}_FETCHED` as const,
    tabId,
    orderId,
    data,
  }),
  secondaryMarketAmendFetchFailed: (tabId: string, orderId: string) => ({
    type: `SECONDARY_MARKET_AMEND_${actionType}_FETCH_FAILED` as const,
    tabId,
    orderId,
  }),
});
